@if (d) {
    <qp-table-data
        [nullValues]=false
        [data]="
            [
                { k: AppStrings.Test_Running, v: d.testrunning | yesno }
            ]
        "

        (selected)="select($event)"
    >
    </qp-table-data>
    <!-- <mat-icon class="tab-icon">{{ Icons.link }}</mat-icon> -->
}